import React, { useEffect, useState } from "react";
import { Search } from "react-feather";
import { Row, Col, Form } from "reactstrap";
import { debounce } from "lodash";
import { useForm } from "react-hook-form";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import searchIcon from "../../../assets/images/tarrifManagement/search.svg";
const TariffSearchFilter = ({
  setSearchData,
  setFilterData,
  searchData,
  setFilterType,
  setQFName,
  setQFValue,
  placeholder,
  isPhoneNumber,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const { register, watch, reset, handleSubmit, setValue } = useForm();

  useEffect(() => {
    if (!searchData) {
      reset();
    } else {
      setValue("searchtable", searchData);
    }
  }, [searchData]);
  const onInputChange = (formValues) => {
    let value = formValues.searchtable;
    value = value.trim();
    setFilterType("search");
    setSearchData(value);
    setFilterData([]);
    try {
      setQFName("");
      setQFValue("");
    } catch (err) {}
  };
  let searchTableInput = watch("searchtable");

  // const debounceData = debounce(onInputChange, 1500);
  return (
    <form onSubmit={handleSubmit(onInputChange)}>
      <TextField
        placeholder={placeholder || "Search"}
        fullWidth
        variant="outlined"
        {...register("searchtable", {
          onChange: (e) => {
            if (isPhoneNumber) {
              setValue("searchtable", e.target.value.replace(/[^0-9]/g, ""));
            } else {
              setValue("searchtable", e.target.value);
            }
          },
        })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img
                src={searchIcon}
                alt="edit"
                style={{ width: "1.67vw", height: "1.67vw" }}
                //   onClick={() => setIsOpenEditClientModal(true)}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px", // custom radius
            width: "16.6vw",
            height: "3.06vw",
            backgroundColor: "white",
            fontWeight: "400",
            letterSpacing: "0.3",
            fontSize: "0.97vw",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(217, 217, 217, 1)", // default border
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(217, 217, 217, 1)",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "rgba(57, 181, 74, 1)", // border color on focus
              borderWidth: "2px",
            },
        }}
      />
    </form>
  );
};

export default TariffSearchFilter;
